<div class="animated fadeInRight">
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    modulo="Promociones" [tituloCard]="idPromo + ' Bonificadores (regalo)'" titulo="Promociones">
  </app-lfsa-card-v2>
</div>

<ng-template #innTemplateButton>
  <div class="col-md-6 text-end mb-2">
    <div *ngIf="!verFormularioAgregarBonificadorRegalo">
      <button class="btn btn-outline-danger me-2" routerLink="..">
        <i class="fas fa-arrow-left"></i>
      </button>
      <button class="btn btn-outline-success" (click)="nuevoBonificadorRegalo()">
        <i aria-hidden="true" class="fa fa-plus"></i>
        Nuevo Regalo
      </button>
    </div>
  </div>
</ng-template>

<ng-template #enviarTemplateEdit>
  <div *ngIf="!verFormularioAgregarBonificadorRegalo">
    <div class="mb-3">
      <button class="btn btn-success" (click)="downloadCsv()"><i class="fas fa-file-csv me-1"></i>Descargar</button>
      <button class="btn btn-danger" (click)="eliminarTodo()">Eliminar todo</button>
    </div>
    <ag-grid-angular #agGridBonificadoresRegalo (gridReady)="onGridReady($event)" class="ag-theme-alpine"
      [columnDefs]="columnDefsBonificadoresRegalo" [floatingFilter]="true" [frameworkComponents]="frameworkComponents"
      id="myGridListGaritas" [ngStyle]="{width: '100%', height: '400px'}" [paginationPageSize]="15"
      [pagination]="true" [rowData]="rowDataBonificadoresRegalo">
    </ag-grid-angular>
  </div>
  <app-promo-regalo-form
    [regalo]="regalo"
    [idPromo]="idPromo"
    [tipoPromo]="tipoPromo"
    [material]="material"
    (back)="back()"
    (create)="guardarBonificadorRegalo($event)"
    *ngIf="verFormularioAgregarBonificadorRegalo"></app-promo-regalo-form>
</ng-template>

<ng-container *ngIf="verFormularioAgregarBonificadorRegalo">
  <app-material-modal (onSelect)="materialSelected($event)"></app-material-modal>
</ng-container>
